(function(){
	var colorpickerAutocompleteCache = null;
	var responseFilter = function(callback,term) {
		if(term.length<2)
			return callback([]);

		var r = colorpickerAutocompleteCache.filter(function(v){
			return v.label.indexOf(term)>=0;
		})
		return callback(r);
	}
	var doOnDocumentLoaded = function(){
		if(ENV_HID>0)
		{
			$('.colorpicker-autocomplete:not(.colorpicker-autocomplete--ready)').each(function(){
				$(this).addClass('colorpicker-autocomplete--ready')
				$(this).autocomplete({
					source: function( request, response ) {
						var term = request.term;

						if(!colorpickerAutocompleteCache)
						{
							$.getJSON( '/admin/HID'+ENV_HID+'/ajax/colorpicker-autocomplete', request, function( data, status, xhr ) {
								colorpickerAutocompleteCache = data;
								responseFilter(response,term);
							});
						}
						else
						{
							responseFilter(response,term);
						}
					},
					select: function( event, ui ) {
						var el = $(event.target)
						setTimeout(function(){
							//console.log(el,ui.item)
							el.val(ui.item.label)
							el.css({background:ui.item.color});
							el.parent().find('.code_parsed').html(ui.item.color);
						},5)
						return false;
					}
				});
				$(this).autocomplete('instance')._renderItem = function( ul, item ) {
					return $( "<li>" )
								.append( `<div style="margin-bottom:5px;border-bottom:5px solid ${item.color};">${item.label} <small>${item.color}</small></div>` )
								.appendTo( ul );
				};
			});
		}
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', doOnDocumentLoaded);
	} else {
		doOnDocumentLoaded();
	}
})();
